var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1522 20.9921C41.8933 20.1417 41.8582 18.8025 41.074 18.0007C40.2879 17.1989 39.05 17.2369 38.3088 18.0853L24.954 33.3745L17.6852 25.054C16.944 24.2057 15.7061 24.1676 14.92 24.9694C14.1358 25.7712 14.1006 27.1104 14.8418 27.9609L23.5324 37.9231C23.902 38.3462 24.4163 38.5789 24.954 38.5789C25.4938 38.5789 26.0082 38.3462 26.3759 37.9231L41.1522 20.9921Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 0C12.536 0 0 12.536 0 28C0 43.46 12.536 56 28 56C43.464 56 56 43.46 56 28C56 12.536 43.464 0 28 0ZM4 28C4 14.746 14.746 4 28 4C41.254 4 52 14.746 52 28C52 41.26 41.254 52 28 52C14.746 52 4 41.26 4 28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMark);
export default __webpack_public_path__ + "static/media/success-mark.82e0b73f9a0730a9a2c612e989566782.svg";
export { ForwardRef as ReactComponent };